import { checkReviewLinkSettings } from "features/meo_site_settings/MeoSiteSettingsActions";
import { ReviewLinkSettings } from "api/sms-api";
import store from "store/store";

export async function setReviewLinkWarning() {
  const result: ReviewLinkSettings | undefined = await store.dispatch(
    checkReviewLinkSettings()
  );
  const element = document.getElementById("reviewUrlWarning");
  if (element) {
    if (result !== undefined && !result.reviewLinkSettingFlag) {
      element.style.visibility = "visible";
    } else {
      element.style.visibility = "hidden";
    }
  }
}
